export enum CancerType {    
    Bladder = 5,
    Bone = 10,
    Brain = 15,
    Breast = 20,
    ColonOrRectal = 25,
    Kidney = 30,
    Liver = 35,
    Lung = 40,
    Melanoma = 45,
    NonHodgkinLymphoma = 50,
    Pancreatic = 55,
    Prostate = 60,
    Skin = 65,
    Thyroid = 70,
    Other = 100
}